import script from "./DirectMessageListing.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectMessageListing.vue?vue&type=script&setup=true&lang=js"

import "./DirectMessageListing.vue?vue&type=style&index=0&id=45f334b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f334b5"]])

export default __exports__